import React from 'react';
import { ChipAvatar } from './ChipAvatar';
import { ChipLabel } from './ChipLabel';
import { ChipField } from './ChipField';
import { ChipCounter } from './ChipCounter';
import { ChipDeleteButton } from './ChipDeleteButton';

const CHIP_PRIMITIVES = new Set<unknown>([
  ChipAvatar,
  ChipLabel,
  ChipField,
  ChipCounter,
  ChipDeleteButton,
]);

/**
 * `true` when `children` contains at least one **direct** chip primitive
 * (wrapping a primitive in `<>...</>` or another component bypasses detection).
 */
export function isComposedChildren(children: React.ReactNode): boolean {
  if (children == null || typeof children !== 'object') {
    return false;
  }
  if (React.isValidElement(children)) {
    return CHIP_PRIMITIVES.has(children.type);
  }
  // `React.Children.toArray` recursively flattens nested arrays produced by
  // adjacent JSX expression slots (e.g. `{a.map(...)}{b.map(...)}` yields
  // `[[...], [...]]`) — `[...].some()` on the un-flattened outer array would
  // miss primitives nested one level deep and silently fall back to simple mode.
  return React.Children.toArray(children).some(
    child => React.isValidElement(child) && CHIP_PRIMITIVES.has(child.type),
  );
}
